import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { RECEPTION_STYLES } from "@/lib/constants";

export const ReceptionStep = ({ reception, onChange }) => {
  const rec = reception || { styles: [], other_style: "", references: "", notes: "" };
  const toggleStyle = (s) => {
    const styles = rec.styles.includes(s)
      ? rec.styles.filter((x) => x !== s)
      : [...rec.styles, s];
    onChange({ ...rec, styles });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      className="mx-auto max-w-2xl"
    >
      <h2 className="font-serif text-2xl font-semibold text-[color:var(--brand-graphite)] sm:text-3xl">
        Recepção pré-cerimonial
      </h2>
      <div className="mt-3 rounded-xl border border-[color:var(--brand-champagne)] bg-[color:var(--brand-champagne-soft)] p-4">
        <p className="text-sm leading-relaxed text-[color:var(--brand-graphite)]">
          A recepção musical pré-cerimonial acontece aproximadamente 30 minutos antes do início
          da cerimônia, enquanto seus convidados chegam e se acomodam. Aqui não é preciso escolher
          músicas específicas — apenas os estilos que combinam com vocês.
        </p>
      </div>

      <div className="mt-6">
        <p className="mb-3 text-sm font-semibold text-[color:var(--brand-graphite)]">
          Estilos musicais desejados <span className="font-normal text-[color:var(--brand-muted)]">(selecione quantos quiser)</span>
        </p>
        <div className="flex flex-wrap gap-2">
          {RECEPTION_STYLES.map((s) => {
            const active = rec.styles.includes(s);
            return (
              <button
                key={s}
                type="button"
                data-testid={`reception-style-chip-${s}`}
                onClick={() => toggleStyle(s)}
                className={`rounded-full border px-3.5 py-2 text-sm transition-colors ${
                  active
                    ? "border-[color:var(--brand-marsala)] bg-[color:var(--brand-marsala-soft)] text-[color:var(--brand-marsala)]"
                    : "border-[color:var(--brand-border)] bg-white text-[color:var(--brand-graphite)] hover:bg-[color:var(--brand-paper)]"
                }`}
              >
                {s}
              </button>
            );
          })}
        </div>
      </div>

      {rec.styles.includes("Outros") && (
        <div className="mt-4">
          <label className="text-sm font-medium text-[color:var(--brand-graphite)]">Especifique "Outros"</label>
          <Input
            data-testid="reception-other-input"
            value={rec.other_style || ""}
            onChange={(e) => onChange({ ...rec, other_style: e.target.value })}
            placeholder="Conte quais outros estilos"
            className="mt-1.5 h-11"
          />
        </div>
      )}

      <div className="mt-6">
        <label className="flex items-center gap-2 text-sm font-semibold text-[color:var(--brand-graphite)]">
          <Sparkles className="h-4 w-4 text-[color:var(--brand-marsala)]" /> Referências musicais
        </label>
        <p className="mb-2 mt-1 text-xs text-[color:var(--brand-muted)]">Artistas, músicas ou referências que vocês amam.</p>
        <Textarea
          data-testid="reception-references-input"
          value={rec.references || ""}
          onChange={(e) => onChange({ ...rec, references: e.target.value })}
          placeholder="Ex: Gostamos de Coldplay, Bruno Mars, Djavan e músicas românticas internacionais."
          className="min-h-[90px]"
        />
      </div>
    </motion.div>
  );
};
